import { c as _c } from "react/compiler-runtime";
import { useShallow } from 'zustand/react/shallow';
import { useDebugStore } from '@/store/use-debug-store';
const LOGS_PER_PAGE = 50;
export const useDebugLogs = () => {
  const $ = _c(14);
  const {
    websocket,
    currentPage,
    isPaused
  } = useDebugStore(useShallow(_temp));
  const {
    logs,
    createdAt,
    lastMessageAt
  } = websocket;
  const reset = useDebugStore(_temp2);
  const setPage = useDebugStore(_temp3);
  const togglePause = useDebugStore(_temp4);
  const totalPages = Math.max(1, Math.ceil(logs.length / LOGS_PER_PAGE));
  const validCurrentPage = Math.max(1, Math.min(currentPage, totalPages));
  let t0;
  if ($[0] !== logs || $[1] !== validCurrentPage) {
    t0 = logs.slice((validCurrentPage - 1) * LOGS_PER_PAGE, validCurrentPage * LOGS_PER_PAGE);
    $[0] = logs;
    $[1] = validCurrentPage;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const paginatedLogs = t0;
  let t1;
  if ($[3] !== createdAt || $[4] !== isPaused || $[5] !== lastMessageAt || $[6] !== logs || $[7] !== paginatedLogs || $[8] !== reset || $[9] !== setPage || $[10] !== togglePause || $[11] !== totalPages || $[12] !== validCurrentPage) {
    t1 = {
      allLogs: logs,
      paginatedLogs,
      createdAt,
      lastMessageAt,
      reset,
      currentPage: validCurrentPage,
      totalPages,
      setPage,
      isPaused,
      togglePause
    };
    $[3] = createdAt;
    $[4] = isPaused;
    $[5] = lastMessageAt;
    $[6] = logs;
    $[7] = paginatedLogs;
    $[8] = reset;
    $[9] = setPage;
    $[10] = togglePause;
    $[11] = totalPages;
    $[12] = validCurrentPage;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  return t1;
};
function _temp(state) {
  return {
    websocket: state.websocket,
    currentPage: state.currentPage,
    isPaused: state.isPaused
  };
}
function _temp2(state_0) {
  return state_0.resetLogs;
}
function _temp3(state_1) {
  return state_1.setPage;
}
function _temp4(state_2) {
  return state_2.togglePause;
}